import React from 'react'
import { Grid } from '@material-ui/core'
import { components, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'
import { VESSEL_OWNERSHIP, VESSEL_POWER_TYPE } from '../Common/constants/entityOptions'
import { COUNTRY_OPTIONS } from '../Common/constants/country'
import ClearableCngSelectField from '../Common/components/ClearableCngSelectField'
import SearchableCountryField from '../Common/components/SearchableCountryField'
import CodeMaintenanceSearchField from '../Common/components/CodeMaintenanceSearchField'
import { CngTextFieldMandatory } from '../Common/components/MandatoryFieldWrappers'
import OrgActingSelector from '../Common/components/OrgActingSelector'
import useOrgFilter from '../Common/hooks/useOrgFilter'

const {
  form: {
    field: { CngTextField, CngSelectField }
  },
  CngGridItem
} = components

const DEFAULT_INITIAL_VALUES = {
  onBehalfOfOrgId: null,
  carrierIdentifier: '',
  imoNumber: '',
  vesselName: '',
  vesselFlagCountry: '',
  vesselOwnershipIndicatorCode: '',
  vesselPowerTypeCode: '',
  vesselPowerTypeDescription: ''
}

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES }
}

function Fields({ disabled, showNotification, shouldHideMap, isEditMode }) {
  const { translate } = useTranslation([Namespace.UAE_MPCI])
  const { canActAsOtherOrg } = useOrgFilter()

  return (
    <Grid container spacing={2}>
      {canActAsOtherOrg && (
        <CngGridItem xs={12} sm={6} md={4}>
          <OrgActingSelector name='onBehalfOfOrgId' disabled={disabled || isEditMode} />
        </CngGridItem>
      )}
      <CngGridItem xs={12} sm={6} md={4}>
        <CodeMaintenanceSearchField
          required
          codeType='SMDG'
          name='carrierIdentifier'
          label='Carrier Identifier'
          disabled={disabled}
          size='small'
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={4}>
        <CngTextFieldMandatory
          required
          name='imoNumber'
          label='IMO Number'
          disabled={disabled || isEditMode}
          size='small'
          inputProps={{ maxLength: 7 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={4}>
        <CngTextFieldMandatory
          required
          name='vesselName'
          label='Vessel Name'
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 70 }}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={4}>
        <SearchableCountryField
          name='vesselFlagCountry'
          label='Vessel Flag Country'
          disabled={disabled}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={4}>
        <ClearableCngSelectField
          name='vesselOwnershipIndicatorCode'
          label='Vessel Ownership Indicator Code'
          disabled={disabled}
          items={VESSEL_OWNERSHIP}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={4}>
        <ClearableCngSelectField
          name='vesselPowerTypeCode'
          label='Vessel Power Type Code'
          disabled={disabled}
          items={VESSEL_POWER_TYPE}
        />
      </CngGridItem>
      <CngGridItem xs={12} sm={6} md={4}>
        <CngTextField
          name='vesselPowerTypeDescription'
          label='Vessel Power Type Description'
          disabled={disabled}
          size='small'
          inputProps={{ maxLength: 17 }}
        />
      </CngGridItem>
    </Grid>
  )
}

function toClientDataFormat(serverData) {
  return {
    ...serverData,
    onBehalfOfOrgId: serverData.orgId ?? null,
    carrierIdentifier: serverData.carrierIdentifier || '',
    imoNumber: serverData.imoNumber || '',
    vesselName: serverData.vesselName || '',
    vesselFlagCountry: serverData.vesselFlagCountry || '',
    vesselOwnershipIndicatorCode: serverData.vesselOwnershipIndicatorCode || '',
    vesselPowerTypeCode: serverData.vesselPowerTypeCode || '',
    vesselPowerTypeDescription: serverData.vesselPowerTypeDescription || ''
  }
}

function toServerDataFormat(localData) {
  return {
    ...localData
  }
}

const FormProperties = {
  formikProps: FORMIK_PROPS,
  Fields,
  toClientDataFormat,
  toServerDataFormat
}

export default FormProperties
